import { Component, Input, OnInit, Inject, inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

import * as _ from 'lodash';
const defaultDataStructure = {
  scrollableHeight: 'auto',
};

@Component({
  selector: 'cm-more-options-modal',
  templateUrl: './more-options-modal.component.html',
  styleUrls: ['./more-options-modal.component.scss'],
})
export class MoreOptionsModalComponent implements OnInit {
  @Input() label: string;
  public data = inject(MAT_BOTTOM_SHEET_DATA);
  constructor(
    private dialogRef: MatBottomSheetRef<MoreOptionsModalComponent>
  ) {}
  ngOnInit() {
    this.data = _.merge(_.cloneDeep(defaultDataStructure), this.data);
  }

  performAction(action: string): void {
    this.dialogRef.dismiss(action);
  }

  closeBottomsheet(event: MouseEvent): void {
    this.dialogRef.dismiss();
    event.preventDefault();
  }
}
